<div class="container py-4">

  <!-- Idle: mode picker -->
  @if (state === 'idle') {
  <div class="row justify-content-center">
    <div class="col-md-5 text-center py-4">
      <div class="fs-1">🇩🇪</div>
      <h3 class="mt-3 fw-bold">{{ 'learnDeutsch.title' | transloco }}</h3>
      <p class="text-muted mb-4">{{ 'learnDeutsch.subtitle' | transloco }}</p>

      <div class="row g-3 mb-4">
        <div class="col-6">
          <div class="card h-100 border-2"
               [class.border-primary]="mode === 'articles'"
               [class.border-light]="mode !== 'articles'"
               style="cursor: pointer;"
               (click)="selectMode('articles')">
            <div class="card-body text-center py-3">
              <i class="bi bi-journal-text fs-2 text-primary"></i>
              <h6 class="fw-bold mb-1 mt-2">{{ 'learnDeutsch.articles' | transloco }}</h6>
              <small class="text-muted">{{ 'learnDeutsch.articlesHint' | transloco }}</small>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card h-100 border-2"
               [class.border-primary]="mode === 'plural'"
               [class.border-light]="mode !== 'plural'"
               style="cursor: pointer;"
               (click)="selectMode('plural')">
            <div class="card-body text-center py-3">
              <i class="bi bi-lightning-charge fs-2 text-success"></i>
              <h6 class="fw-bold mb-1 mt-2">{{ 'learnDeutsch.plural' | transloco }}</h6>
              <small class="text-muted">{{ 'learnDeutsch.pluralHint' | transloco }}</small>
            </div>
          </div>
        </div>
      </div>

      <button class="btn btn-primary btn-lg w-100" (click)="start()">
        <i class="bi bi-play-fill me-2"></i>{{ 'learnDeutsch.startPractice' | transloco }}
      </button>

      <p class="mt-4 mb-0 small text-muted">
        {{ 'learnDeutsch.wantOwnWords' | transloco }}
        <a routerLink="/register" class="fw-semibold">{{ 'learnDeutsch.createFreeAccount' | transloco }}</a>
      </p>
    </div>
  </div>
  }

  <!-- Loading -->
  @if (state === 'loading') {
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading…</span>
    </div>
    <p class="mt-3 text-muted">{{ 'learnDeutsch.loading' | transloco }}</p>
  </div>
  }

  <!-- Error -->
  @if (state === 'error') {
  <div class="row justify-content-center">
    <div class="col-md-5 text-center py-5">
      <i class="bi bi-exclamation-triangle-fill fs-1 text-danger"></i>
      <h5 class="mt-3">{{ 'learnDeutsch.errorTitle' | transloco }}</h5>
      <p class="text-muted">{{ 'learnDeutsch.errorMessage' | transloco }}</p>
      <button class="btn btn-outline-primary" (click)="start()">
        <i class="bi bi-arrow-clockwise me-1"></i>{{ 'learnDeutsch.retry' | transloco }}
      </button>
    </div>
  </div>
  }

  <!-- Practicing -->
  @if (state === 'practicing') {
  <div class="row justify-content-center">
    <div class="col-md-7 col-lg-6">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <span class="fs-3">🇩🇪</span>
        <button class="btn btn-sm btn-outline-secondary" (click)="backToMenu()">
          {{ 'learnDeutsch.changeMode' | transloco }}
        </button>
      </div>

      <!-- Progress -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="text-muted small">
          {{ 'learnDeutsch.cardProgress' | transloco: { current: currentIndex + 1, total: items.length } }}
        </span>
        <div class="d-flex gap-3 small">
          <span class="text-success"><i class="bi bi-check-circle-fill"></i> {{ correctCount }}</span>
          <span class="text-danger"><i class="bi bi-x-circle-fill"></i> {{ wrongCount }}</span>
        </div>
      </div>

      <div class="progress mb-4" style="height: 6px;">
        <div class="progress-bar" [style.width.%]="(currentIndex / items.length) * 100"></div>
      </div>

      <!-- Word card -->
      <div class="card border-0 shadow-sm mb-3">
        <div class="card-body text-center py-4">
          <p class="text-muted small mb-2">
            @if (mode === 'articles') {
              {{ 'learnDeutsch.whatArticle' | transloco }}
            } @else {
              {{ 'learnDeutsch.whatPlural' | transloco }}
            }
          </p>
          <h2 class="fw-bold mb-0">{{ current.word }}</h2>

          @if (isAnswered) {
            <div class="mt-3">
              <span class="badge bg-light text-dark border fs-6">{{ current.hint }}</span>
            </div>
            @if (current.translation) {
              <p class="text-muted small mb-0 mt-2">{{ current.translation }}</p>
            }
          }
        </div>
      </div>

      <!-- Options -->
      <div class="row g-2">
        @for (option of current.options; track option) {
          <div [class]="optionColClass">
            <button class="btn w-100 btn-lg"
                    [ngClass]="getButtonNgClass(option)"
                    [disabled]="isAnswered"
                    (click)="answer(option)">
              {{ option }}
            </button>
          </div>
        }
      </div>

      <!-- Feedback + timer + Next -->
      @if (isAnswered) {
        @if (!isHeld) {
          <div class="progress mt-3" style="height: 4px;">
            <div class="progress-bar bg-secondary" [style.width.%]="timerProgress"></div>
          </div>
        }
        <div class="d-flex align-items-center justify-content-between mt-2">
          @if (isCorrect) {
            <span class="badge bg-success px-3 py-2 fs-6">
              <i class="bi bi-check-circle-fill me-1"></i>{{ 'learnDeutsch.correct' | transloco }}
            </span>
          } @else {
            <span class="badge bg-danger px-3 py-2 fs-6">
              <i class="bi bi-x-circle-fill me-1"></i>{{ 'learnDeutsch.wrong' | transloco }}
              — {{ current.correctAnswer }}
            </span>
          }
          <div class="d-flex gap-2">
            @if (!isHeld) {
              <button class="btn btn-sm btn-outline-secondary" (click)="hold()">
                <i class="bi bi-pause-fill me-1"></i>Hold
              </button>
            }
            <button class="btn btn-primary" (click)="next()">
              {{ 'learnDeutsch.next' | transloco }} <i class="bi bi-arrow-right ms-1"></i>
            </button>
          </div>
        </div>

        <!-- Examples — shown below the action bar -->
        @if (current.examples.length > 0) {
          <div class="mt-3 pt-3 border-top">
            @for (ex of current.examples; track ex.sentenceDe) {
              <p class="small fst-italic text-secondary mb-1">{{ ex.sentenceDe }}</p>
              <p class="small text-muted mb-2">{{ ex.sentenceTranslation }}</p>
            }
            <div>
              <button class="btn btn-sm" (click)="copyExample()"
                      [class.btn-outline-secondary]="!copied"
                      [class.btn-success]="copied">
                @if (copied) {
                  <i class="bi bi-check-lg me-1"></i>Copied!
                } @else {
                  <i class="bi bi-clipboard me-1"></i>Copy
                }
              </button>
            </div>
          </div>
        }
      }

    </div>
  </div>
  }

  <!-- Complete -->
  @if (state === 'complete') {
  <div class="row justify-content-center">
    <div class="col-md-6 text-center py-4">
      <i class="bi bi-trophy-fill fs-1 text-warning"></i>
      <h3 class="mt-3">{{ 'learnDeutsch.sessionComplete' | transloco }}</h3>
      <p class="text-muted">{{ 'learnDeutsch.reviewed' | transloco: { total: items.length } }}</p>

      <div class="row g-3 my-3">
        <div class="col-6">
          <div class="card border-0 bg-success bg-opacity-10 py-3">
            <div class="fs-2 fw-bold text-success">{{ correctCount }}</div>
            <div class="small text-muted">{{ 'learnDeutsch.correct' | transloco }}</div>
          </div>
        </div>
        <div class="col-6">
          <div class="card border-0 bg-danger bg-opacity-10 py-3">
            <div class="fs-2 fw-bold text-danger">{{ wrongCount }}</div>
            <div class="small text-muted">{{ 'learnDeutsch.wrong' | transloco }}</div>
          </div>
        </div>
      </div>

      <div class="d-flex gap-2 justify-content-center mt-3">
        <button class="btn btn-outline-primary" (click)="restart()">
          <i class="bi bi-arrow-clockwise me-2"></i>{{ 'learnDeutsch.practiceAgain' | transloco }}
        </button>
        <button class="btn btn-outline-secondary" (click)="backToMenu()">
          {{ 'learnDeutsch.changeMode' | transloco }}
        </button>
      </div>

      <div class="card border-0 bg-primary bg-opacity-10 mt-4 p-4">
        <h5 class="fw-bold mb-2">{{ 'learnDeutsch.ctaTitle' | transloco }}</h5>
        <p class="text-muted small mb-3">{{ 'learnDeutsch.ctaSubtitle' | transloco }}</p>
        <a routerLink="/register" class="btn btn-primary">
          <i class="bi bi-person-plus me-2"></i>{{ 'learnDeutsch.createAccountBtn' | transloco }}
        </a>
        <p class="mt-2 mb-0 small text-muted">
          {{ 'learnDeutsch.alreadyHaveAccount' | transloco }}
          <a routerLink="/">{{ 'learnDeutsch.logIn' | transloco }}</a>
        </p>
      </div>

    </div>
  </div>
  }

</div>
